import React from "react"

import { Title } from "../styles"
import { Wrapper, OrderedList, OrderedListItem } from "./styles"

const RecipeSteps = ({ steps }) => (
  <Wrapper>
    <Title>{steps.title ? steps.title : "Instructions"}</Title>
    <OrderedList>
      {steps.items.map(({ text }) => (
        <OrderedListItem key={text} dangerouslySetInnerHTML={{ __html: text }} />
      ))}
    </OrderedList>
  </Wrapper>
)

export default RecipeSteps
